import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  getAllReports,
  getGFPADetailsReport,
  getGFPASummaryReport,
  getGFRSummaryReport,
} from '@services/axiomReport.service'

import { IReportDTO2 } from '@/interfaces/report.interface'

import {
  IGfpaDetailsDTO,
  IGfpaSummaryDTO,
} from '@/interfaces/gfpaReport.interface'

import { IGfrRiskHistoryDTO } from '@/interfaces/gfrReport.interface'

interface AxiomReportState {
  selectedReport: IReportDTO2
  showLoader: boolean
  allReportsSummary: IReportDTO2[]
  rvReport: {
    selectedSummarySeriesName: string
  }
  gfpaReport: {
    summary: IGfpaSummaryDTO[]
    details: IGfpaDetailsDTO[]
    selectedSummarySeriesName: string
  }
  gfrReport: {
    summary: IGfrRiskHistoryDTO[]
  }
}

const initialState: AxiomReportState = {
  selectedReport: {} as IReportDTO2,
  showLoader: false,
  allReportsSummary: [] as IReportDTO2[],
  rvReport: {
    selectedSummarySeriesName: 'Portfolio',
  },
  gfpaReport: {
    summary: [] as IGfpaSummaryDTO[],
    details: [] as IGfpaDetailsDTO[],
    selectedSummarySeriesName: 'Portfolio',
  },
  gfrReport: {
    summary: [] as IGfrRiskHistoryDTO[],
  },
}

export const axiomReportSlice = createSlice({
  name: 'axiomReport',
  initialState,
  reducers: {
    setSelectedReport: (state, action: PayloadAction<IReportDTO2>) => {
      state.selectedReport = action.payload
    },
    setAllReportsSummary: (state, action: PayloadAction<IReportDTO2[]>) => {
      state.allReportsSummary = action.payload
    },
    setGfpaSummary: (state, action: PayloadAction<IGfpaSummaryDTO[]>) => {
      state.gfpaReport.summary = action.payload
    },
    setGfpaDetails: (state, action: PayloadAction<IGfpaDetailsDTO[]>) => {
      state.gfpaReport.details = action.payload
    },
    setGfrSummary: (state, action: PayloadAction<IGfrRiskHistoryDTO[]>) => {
      state.gfrReport.summary = action.payload
    },

    clearReportData: (state) => {
      state.selectedReport = initialState.selectedReport
      state.rvReport = initialState.rvReport
      state.gfpaReport = initialState.gfpaReport
      state.gfrReport = initialState.gfrReport
    },
    clearGFPASummary: (state) => {
      state.gfpaReport.summary = initialState.gfpaReport.summary
    },
    clearGFPADetails: (state) => {
      state.gfpaReport.details = initialState.gfpaReport.details
    },
    clearGFRSummary: (state) => {
      state.gfrReport.summary = initialState.gfrReport.summary
    },
    setShowLoader: (state, action: PayloadAction<boolean>) => {
      state.showLoader = action.payload
    },
    clearAll: (state) => {
      state.allReportsSummary = initialState.allReportsSummary
      state.selectedReport = initialState.selectedReport
      state.rvReport = initialState.rvReport
      state.gfpaReport = initialState.gfpaReport
      state.gfrReport = initialState.gfrReport
    },
  },
})

export const {
  setSelectedReport,
  setAllReportsSummary,
  setGfpaSummary,
  setGfrSummary,
  clearReportData,
  clearGFPASummary,
  clearGFPADetails,
  clearGFRSummary,
  setShowLoader,
  setGfpaDetails,
  clearAll,
} = axiomReportSlice.actions

export default axiomReportSlice.reducer

export const fetchAllReportsAsync = () => (dispatch: Function) => {
  dispatch(setShowLoader(true))
  dispatch(clearAll())
  getAllReports()
    .then((response: IReportDTO2[]) => {
      dispatch(setShowLoader(false))
      return dispatch(setAllReportsSummary(response))
    })
    .catch((error) => {
      dispatch(setShowLoader(false))
      console.error('Fetch all report', error)
    })
}

export const fetchGFPASummaryAsync = (id: number) => (dispatch: Function) => {
  dispatch(setShowLoader(true))
  getGFPASummaryReport(id)
    .then((response) => {
      dispatch(setShowLoader(false))
      return dispatch(setGfpaSummary(response))
    })
    .catch((error) => {
      dispatch(setShowLoader(false))
      console.error('fetch gfpa report summary', error)
    })
}

export const fetchGFRSummaryAsync =
  (id: number, beginDate: string, endDate: string) => (dispatch: Function) => {
    dispatch(setShowLoader(true))
    getGFRSummaryReport(id, beginDate, endDate)
      .then((response) => {
        dispatch(setShowLoader(false))
        return dispatch(setGfrSummary(response))
      })
      .catch((error) => {
        dispatch(setShowLoader(false))
        console.error('fetch gfr report risk history', error)
      })
  }

export const fetchGFPADetailsAsync =
  (id: number, seriesName: string) => (dispatch: Function) => {
    dispatch(setShowLoader(true))
    getGFPADetailsReport(id, seriesName)
      .then((response) => {
        dispatch(setShowLoader(false))
        return dispatch(setGfpaDetails(response))
      })
      .catch((error) => {
        dispatch(setShowLoader(false))
        console.error(`fetch GFPA details`, error)
      })
  }
